<template>
  <Row>
    <Alert type="error" show-icon v-show="showErrorAlert">
      Failed <span slot="desc"> Couldn't change password </span>
    </Alert>

    <Card dis-hover>
      <h1 slot="title">Change Password</h1>
      <i-form ref="form" :model="form" :rules="rules">
        <i-form-item prop="password" label="New Password">
          <i-input type="password" v-model="form.password" />
        </i-form-item>
        <i-form-item prop="confirm" label="Confirm Password">
          <i-input type="password" v-model="form.confirm" />
        </i-form-item>
        <i-form-item>
          <i-button type="primary" @click="submit">Update</i-button>
        </i-form-item>
      </i-form>
    </Card>
  </Row>
</template>

<script>
export default {
  data() {
    return {
      showErrorAlert: false,
      form: {
        confirm: "",
        password: "",
      },
      rules: {
        password: {
          required: true,
          message: "New password field is required",
          trigger: "blur",
        },
        confirm: [
          {
            required: true,
            message: "Confirm password field is required",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              let errors = [];
              if (value !== this.form.password) {
                errors.push("Both fields must match");
              }
              callback(errors);
            },
          },
        ],
      },
    };
  },
  methods: {
    submit() {
      if (this.$can("update", "password")) {
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.changePassword(this.form.password)
              .then(() => {
                this.successNotice("Password has been updated");
                this.$router.push("/");
              })
              .catch(() => {
                this.errorNotice("Failed to update password");
              });
          }
        });
      }
    },
  },
};
</script>

<style lang="css"></style>
